import { useCallback } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../stores/Auth/AuthStore";
import {
  requestPasswordReset,
  resetPassword,
} from "../services/Auth/AuthServices";
import {
  FORM_MODES,
  SUCCESS_MESSAGES,
  API_ERROR_MESSAGES,
  ERROR_MESSAGES,
} from "../config/authModalConfig/constants";

export const useAuthSubmit = (modeForm, close, setModeForm) => {
  const navigate = useNavigate();
  const { login, register, isLoading, setRemember } = useAuthStore();

  const handleSubmit = useCallback(
    async (formData, rememberLogIn, resetForm) => {
      let result;

      try {
        switch (modeForm) {
          case FORM_MODES.LOGIN:
            result = await login({ ...formData, remember: rememberLogIn });

            if (result?.success) {
              toast.success(SUCCESS_MESSAGES.LOGIN_SUCCESS);
              close();
              setRemember(rememberLogIn);
              resetForm();
              navigate(0);
            } else {
              toast.error(result?.error || API_ERROR_MESSAGES.LOGIN_FAILED);
            }
            break;

          case FORM_MODES.REGISTER:
            const registerData = {
              username: formData.username,
              email: formData.email,
              phone: formData.phone,
              firstName: formData.firstName,
              lastName: formData.lastName,
              password: formData.password,
              RePassword: formData.RePassword,
            };

            result = await register(registerData);

            if (result?.success) {
              toast.success(
                result.message || SUCCESS_MESSAGES.REGISTER_SUCCESS
              );
              setModeForm(FORM_MODES.LOGIN);
              resetForm();
            } else {
              toast.error(result?.error || API_ERROR_MESSAGES.REGISTER_FAILED);
            }
            break;

          case FORM_MODES.FORGOT_PASSWORD:
            const forgotPasswordData = { email: formData.email };
            result = await requestPasswordReset(forgotPasswordData);

            if (result?.success) {
              toast.success(
                result.message || SUCCESS_MESSAGES.PASSWORD_RESET_SENT
              );
              setModeForm(FORM_MODES.LOGIN);
              resetForm();
            } else {
              toast.error(
                result.message || API_ERROR_MESSAGES.PASSWORD_RESET_SENT_FAILED
              );
            }
            break;

          case FORM_MODES.RESET_PASSWORD:
            const resetKey = sessionStorage.getItem("resetPasswordKey");
            const resetLogin = sessionStorage.getItem("resetPasswordLogin");

            if (!resetKey || !resetLogin) {
              toast.error(ERROR_MESSAGES.INVALID_RESET_INFO);
              return;
            }

            const resetPasswordData = {
              key: resetKey,
              login: resetLogin,
              password: formData.password,
              RePassword: formData.RePassword,
            };

            result = await resetPassword(resetPasswordData);

            if (result?.success) {
              toast.success(
                result.message || SUCCESS_MESSAGES.PASSWORD_RESET_SUCCESS
              );
              sessionStorage.removeItem("resetPasswordKey");
              sessionStorage.removeItem("resetPasswordLogin");
              setModeForm(FORM_MODES.LOGIN);
              resetForm();
            } else {
              toast.error(
                result?.error || API_ERROR_MESSAGES.PASSWORD_RESET_FAILED
              );
            }
            break;

          default:
            console.error("Unknown form mode:", modeForm);
        }
      } catch (error) {
        console.error("Submit error:", error);
        toast.error("Đã xảy ra lỗi không mong muốn");
      }
    },
    [modeForm, login, register, close, setRemember, navigate, setModeForm]
  );

  return {
    handleSubmit,
    isLoading,
  };
};
